import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import videoSource from "./img/IMG_0068.mp4";
import videoSource2 from "./img/IMG_0158_1.mp4";
import videoSource3 from "./img/CNC.mp4";
import videoSource4 from "./img/IMG_8154.mp4";
import img1 from "./img/WhatsApp Image 2025-11-03 at 11_imgupscaler.ai_V1(Fast)_2K.jpg";
// import img2 from "./logofr.jpg";
// import img2 from "./Calque 1.png";
import img2 from "./img/Calque 1 copie 2.png";

// import img2 from "./img/logo111.png";
// import img2 from "./img/Impression Haute Définition unik system.JPG";

export default function Services() {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="services-page">
      {/* ================= VIDEO HERO ================= */}
      <section className="services-video">
        <div className="video-overlay">
          <h1 data-aos="fade-up">Nos Services</h1>
          <p data-aos="fade-up" data-aos-delay="200">
            Solutions architecturales, impression grand format & découpe laser
          </p>
        </div>

        <video autoPlay muted loop playsInline loading="lazy">
          <source src={videoSource} type="video/mp4" loading="lazy"/>
        </video>
      </section>
      <section className="sd-layout sd-reverse">
        {/* TEXTE */}
        <div className="sd-text">
          <h5 className="section-titles" data-aos="fade-up">
            Notre expertise au service de vos projets architecturaux
          </h5>
          <br />
          <p data-aos="fade-up">
            Chez <strong>UNIK SYSTEM</strong>, nous concevons chaque projet
            comme une œuvre unique, pensée pour allier esthétique, performance
            technique et durabilité. De la première idée jusqu’à la livraison
            finale, notre équipe vous accompagne avec une approche globale,
            rigoureuse et entièrement personnalisée, adaptée aux exigences des
            espaces résidentiels, commerciaux et professionnels.
            <br />
          </p>
          <p data-aos="fade-up">
            Forts de notre expertise technique et de notre atelier de production
            intégré, nous maîtrisons l’ensemble de la chaîne de valeur : étude
            préalable, ingénierie, conception sur mesure, fabrication de haute
            précision, installation sur site et service après-vente. Cette
            maîtrise complète nous permet de garantir un niveau de qualité
            constant, des délais respectés et un rendu final irréprochable.
            <br />
          </p>
          <p data-aos="fade-up">
            Spécialisés dans les plafonds et murs tendus, l’éclairage intégré,
            les solutions acoustiques, les façades textiles, la protection
            solaire et l’architecture textile, nous utilisons des matériaux
            innovants et des technologies de pointe pour transformer vos espaces
            en environnements modernes, fonctionnels et esthétiques. Chaque
            solution est étudiée pour répondre aux contraintes techniques tout
            en valorisant l’identité visuelle de votre projet.
            <br />
          </p>
          <p data-aos="fade-up">
            Notre engagement ne s’arrête pas à l’installation. Nous assurons un
            suivi professionnel et un service après-vente réactif afin de
            garantir la pérennité et la performance de nos réalisations dans le
            temps. Avec <strong>UNIK SYSTEM</strong>, vous bénéficiez d’un
            accompagnement complet, fiable et transparent, pour des projets
            maîtrisés de A à Z et des résultats qui dépassent vos attentes.
          </p>
        </div>

        {/* IMAGE */}
        <div className="sd-photo-box">
          <img src={img1} alt="Service UNIK" loading="lazy"/>
        </div>
      </section>

      {/* ================= INTRO ================= */}
      <section className="services-intro container ">
        <h2 data-aos="fade-up" className="section-titles">
          L’expertise UNIK SYSTEM
        </h2>
        <p data-aos="fade-up" style={{ color: "#807773" }}>
          
            Nous accompagnons vos projets de la conception à l’installation avec
            des solutions innovantes, durables et sur-mesure.
          
        </p>
        <section className="sd-layout">
          {/* TEXTE */}
          <div className="sd-text">
            <h5 data-aos="fade-up" className="section-titles">
              Impression Haute Définition (HD & UV)
            </h5>

            <p data-aos="fade-up">
              Nous proposons des solutions d’impression haute définition
              professionnelle, adaptées aux projets de décoration, communication
              visuelle et aménagement intérieur/extérieur.
              <br />
              <br />
              <b>🔧 Technologies utilisées</b>
              <br />
              <br />• Impression UV haute définition
              <br />• Impression numérique grand format
              <br />• Encres UV résistantes aux UV, à l’humidité et aux rayures
              <br />• Excellente tenue des couleurs dans le temps
              <br />
            </p>
            <p data-aos="fade-up">
              <b>🧩 Supports imprimables</b>
              <br />
              <br />• Plexiglass (PMMA)
              <br />• PVC, Forex
              <br />• Aluminium composite (Dibond)
              <br />• Bois, MDF
              <br />• Verre (selon projet)
              <br />• Toile, vinyle, films décoratifs
              <br />• Feutrine décorative et acoustique
              <br />
            </p>
            <p data-aos="fade-up">
              <b>🎯 Avantages techniques</b>
              <br />
              <br />• Très haute résolution (détails fins, textes nets, couleurs
              profondes)
              <br />• Impression directe sur support rigide (sans collage
              intermédiaire)
              <br />• Résistance aux conditions extérieures
              <br />• Possibilité de blanc de soutien, vernis sélectif et effets
              spéciaux
              <br />• Finitions personnalisées selon usage décoratif ou
              signalétique
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              <b>🏢 Applications</b>
              <br />
              <br />• Décoration murale intérieure
              <br />• Enseignes & signalétique
              <br />• Habillage de stands & showrooms
              <br />• Tableaux décoratifs
              <br />• Revêtements muraux imprimés
              <br />• Projets architecturaux et commerciaux
            </p>
            <a
              data-aos="fade-up"
              className="btn-project"
              href="/docs/catalogue-unik-system.pdf"
              download
            >
              <i class="fa-solid fa-file-arrow-down p-1"></i> Télécharger le
              document
            </a>
            <br />
            <br />
            <br />
            <br />
          </div>

          {/* IMAGE */}
          <div className="sd-photo-box" data-aos="fade-up-right">
            {/* <img
            src={img2} alt="Service UNIK"
          /> */}
          <img
          className="img-logo" style={{width:"70px", height:"auto"}} src={img2} alt="Service UNIK"
          />
            <video autoPlay muted loop playsInline loading="lazy" className="viv">
              <source src={videoSource4} type="video/mp4" loading="lazy" />
            </video>
          </div>
        </section>
        <section className="sd-layout sd-reverse">
          {/* TEXTE */}
          <div className="sd-text">
            <h5 data-aos="fade-up" className="section-titles">
              Découpe Laser Métal – Précision & Performance B2B
            </h5>
            <br />
            <p data-aos="fade-up">
              Nous proposons un service de découpe laser métal de haute
              précision, dédié aux projets architecturaux, décoratifs et
              industriels, nécessitant un haut niveau d’exactitude
              dimensionnelle, de qualité de coupe et de répétabilité.
              <br />
              Notre technologie de découpe laser permet la fabrication de pièces
              sur mesure, avec des tolérances serrées et des finitions propres,
              tout en respectant les exigences techniques définies dans le
              cahier des charges du client.
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              <b>⚙️ Technologie & capacités de découpe</b>
              <br />
              <br />• Découpe laser CNC haute précision
              <br />• Excellente qualité de bord, sans bavures ni déformations
              <br />• Respect strict des géométries complexes et des détails
              fins
              <br />• Très bonne répétabilité pour production unitaire ou en
              série
              <br />• Optimisation des chutes et du rendement matière
              <br />• La découpe est réalisée à partir de fichiers techniques
              vectoriels (DXF, DWG, AI, etc.) ou à partir de plans fournis par
              le client.
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              <b>🔩 Matériaux métalliques traités</b>
              <br />
              <br />
              <b>• Acier noir (acier carbone)</b>
              Utilisé pour des applications structurelles, décoratives et
              industrielles. Il offre une excellente résistance mécanique et une
              grande polyvalence. Des traitements de finition (peinture,
              thermolaquage, protection anticorrosion) peuvent être appliqués
              selon l’usage final.
              <br />
              <b>• Acier inoxydable (Inox)</b>
              Matériau hautement résistant à la corrosion, idéal pour les
              environnements intérieurs et extérieurs. L’inox est privilégié
              pour les projets nécessitant une finition soignée, une grande
              durabilité et une résistance aux conditions humides ou agressives.
              <br />
              <b>• Aluminium</b>
              Léger, stable et résistant, l’aluminium est parfaitement adapté
              aux applications décoratives, architecturales et techniques. Il
              permet une excellente précision de découpe et une intégration
              facile dans les projets B2B.
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              👉 Les épaisseurs traitées sont définies en fonction du matériau,
              des contraintes techniques et du cahier des charges du projet.
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              <b>🏗️ Applications professionnelles</b>
              <br />
              <br />• Panneaux décoratifs métalliques
              <br />• Claustras et habillages architecturaux
              <br />• Signalétique métallique
              <br />• Logos et lettrages découpés
              <br />• Éléments techniques et pièces industrielles
              <br />• Projets sur mesure pour architectes et designers
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              <b>🤝 Accompagnement professionnel</b>
              <br />
              Nous accompagnons nos clients de l’étude technique à la
              fabrication, en apportant des conseils sur le choix du matériau,
              l’épaisseur, la finition et la faisabilité technique, afin de
              garantir un résultat conforme aux exigences esthétiques et
              fonctionnelles du projet
              <br />
            </p>
            <a
              data-aos="fade-up"
              className="btn-project"
              href="/docs/catalogue-unik-system.pdf"
              download
            >
              <i class="fa-solid fa-file-arrow-down p-1"></i> Télécharger le
              document
            </a>
            <br />
            <br />
            <br />
            <br />
          </div>

          {/* IMAGE */}
          <div className="sd-photo-box" data-aos="fade-up-left">
            {/* <img
            src="https://sour-pink-uxflvf9kqu-izrc6e1gjk.edgeone.dev/WhatsApp%20Image%202025-11-03%20at%2011.16.40.jpeg" alt="Service UNIK"
          /> */}
          <img
           className="img-logo" style={{width:"70px", height:"auto"}} src={img2} alt="Service UNIK"
          />
            <video autoPlay muted loop playsInline loading="lazy" className="viv">
              <source src={videoSource2} type="video/mp4" loading="lazy"/>
            </video>
          </div>
        </section>
        <section className="sd-layout">
          {/* TEXTE */}
          <div className="sd-text">
            <h5 data-aos="fade-up" className="section-titles">
              Découpe CNC – Usinage Numérique de Précision
            </h5>
            <br />
            <p data-aos="fade-up">
              Nous proposons un service de découpe et usinage CNC professionnel,
              destiné aux projets architecturaux, décoratifs et techniques,
              nécessitant une grande précision, une parfaite répétabilité et une
              maîtrise rigoureuse des dimensions.
              <br />
              Grâce à la technologie CNC, nous réalisons des pièces sur mesure,
              en production unitaire ou en série, conformément aux exigences
              définies dans le cahier des charges du client.
              <br />
            </p>
            <p data-aos="fade-up">
              <b>⚙️ Technologie & capacités d’usinage</b>
              <br />
              <br />• Usinage CNC haute précision
              <br />• Découpe, fraisage et gravure numérique
              <br />• Usinage 2D et 3D
              <br />• Excellente stabilité dimensionnelle
              <br />• Respect strict des géométries complexes
              <br />• Optimisation matière et réduction des pertes
              <br />• Fabrication à partir de fichiers techniques (DXF, DWG,
              STEP, STL)
              <br />
            </p>
            <p data-aos="fade-up">
              <b>🧱 Supports usinés CNC</b>
              <br />
              <br />
              <b>• Plexiglass (PMMA)</b>
              Usinage précis pour des applications décoratives, signalétiques et
              architecturales. Permet des finitions nettes, des formes complexes
              et une excellente transparence ou diffusion lumineuse.
              <br />
            </p>
            <p data-aos="fade-up">
              <b>• Aluminium composite (Dibond)</b>
              Panneau léger et rigide, idéal pour l’habillage architectural, la
              signalétique professionnelle et les projets décoratifs intérieurs
              et extérieurs.
              <br />
            </p>
            <p data-aos="fade-up">
              <b>• PVC / Forex</b>
              Matériau synthétique polyvalent, facile à usiner, offrant une
              bonne stabilité dimensionnelle pour les applications décoratives,
              signalétiques et techniques.
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              <b>• Bois & panneaux dérivés</b>
              <br />
              Usinage CNC de différents supports à base de bois, adaptés aux
              projets d’aménagement intérieur, mobilier décoratif et éléments
              architecturaux :<br />
              Bois massif : esthétique naturelle et robustesse, selon
              disponibilité et cahier des charges
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              <b>MDF (Medium Density Fiberboard) : </b>
              excellent rendu de coupe et de finition, idéal pour la décoration
              et le mobilier.
              <br />
            </p>
            <p data-aos="fade-up">
              <b>HDF (High Density Fiberboard) :</b>
              densité élevée offrant une meilleure résistance mécanique.
              <br />
            </p>
            <p data-aos="fade-up">
              <b>HPL (High Pressure Laminate) :</b>
              stratifié haute pression, très résistant aux chocs, à l’humidité
              et à l’usure.
              <br />
            </p>
            <p data-aos="fade-up">
              <b>Autres panneaux dérivés du bois : </b>
              selon contraintes techniques et spécifications du projet
              <br />
              <b>Verre (selon cahier des charges) :</b>
              Usinage spécifique réalisé sous conditions techniques définies,
              destiné à des applications décoratives ou architecturales
              particulières.
              <br />
              <br />
              <b>
                👉 Les épaisseurs, tolérances et finitions sont définies en
                fonction du matériau, de l’usage final et des exigences
                techniques du projet.
              </b>
              <br />
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              <b>🏗️ Applications professionnelles</b>
              <br />
              <br />• Panneaux décoratifs et muraux
              <br />• Signalétique et habillage de façades
              <br />• Mobilier et éléments d’aménagement intérieur
              <br />• Claustras et structures décoratives
              <br />• Projets sur mesure pour architectes, designers et
              entreprises
              <br />
              <br />
            </p>
            <p data-aos="fade-up">
              <b>🤝 Accompagnement B2B</b>
              <br />
              Nous accompagnons nos partenaires professionnels dès la phase
              d’étude, en apportant un conseil technique sur le choix des
              matériaux, les épaisseurs, les finitions et la faisabilité du
              projet, afin de garantir un résultat conforme aux exigences
              esthétiques, fonctionnelles et budgétaires.
            </p>
            <a
              data-aos="fade-up"
              className="btn-project"
              href="/docs/catalogue-unik-system.pdf"
              download
            >
              <i class="fa-solid fa-file-arrow-down p-1"></i> Télécharger le
              document
            </a>
            <br />
            <br />
            <br />
            <br />
          </div>

          {/* IMAGE */}
          <div className="sd-photo-box" data-aos="fade-up-right">
            {/* <img
            src="https://sour-pink-uxflvf9kqu-izrc6e1gjk.edgeone.dev/WhatsApp%20Image%202025-11-03%20at%2011.16.40.jpeg" alt="Service UNIK"
          /> */}
          <img
           className="img-logo" style={{width:"70px", height:"auto"}} src={img2} alt="Service UNIK"
          />
            <video autoPlay muted loop playsInline loading="lazy" className="viv">
              <source src={videoSource3} type="video/mp4" loading="lazy"/>
            </video>
          </div>
        </section>
      </section>

      {/* ================= SERVICES CARDS ================= */}
      <div className="container titre-gallry projects-header">
        <h2 data-aos="fade-up" className="section-titles">
          L’expertise UNIK SYSTEM
        </h2>
        <p data-aos="fade-up" style={{ color: "#807773" }}>
          
            Nous accompagnons vos projets de la conception à l’installation avec
            des solutions innovantes, durables et sur-mesure
          
        </p>
      </div>
      <section className="services-cards">
        <div className="card" data-aos="fade-up">
          <i class="fa-solid fa-ruler-combined"></i>

          <h5> Analyse & étude du projet</h5>
          <p>
            Analyse approfondie des besoins, des contraintes techniques et de
            l’usage final.
            <br />
            Nous conseillons sur le choix des matériaux, finitions et solutions
            les plus adaptées afin de garantir la faisabilité et la performance
            du projet.
          </p>
        </div>

        <div className="card" data-aos="fade-up" data-aos-delay="100">
          <i class="fa-solid fa-file-signature"></i>

          <h5>Validation technique & Devis</h5>
          <p>
            Validation des dimensions, matériaux et contraintes techniques.
            <br />
            Élaboration d’un devis clair et détaillé avec cahier des charges
            précis avant tout lancement en production.
          </p>
        </div>

        <div className="card" data-aos="fade-up" data-aos-delay="200">
          <i class="fa-solid fa-laptop-code"></i>

          <h5>Préparation & Programmation</h5>
          <p>
            Optimisation et vérification des fichiers techniques (DXF, DWG,
            AI…).
            <br />
            Programmation CNC et laser avec simulations pour assurer précision,
            répétabilité et optimisation matière.
          </p>
        </div>

        <div className="card" data-aos="fade-up" data-aos-delay="300">
          <i class="fa-solid fa-industry"></i>

          <h5>Fabrication & Impression</h5>
          <p>
            Fabrication professionnelle par découpe CNC, découpe laser et
            impression UV haute définition sur supports rigides et souples,
            conformément aux spécifications validées.
          </p>
        </div>

        <div className="card" data-aos="fade-up" data-aos-delay="400">
          <i class="fa-solid fa-screwdriver-wrench"></i>

          <h5>Contrôle qualité, Livraison & SAV</h5>
          <p>
            Contrôle qualité rigoureux, finitions soignées, conditionnement
            sécurisé et livraison maîtrisée.
            <br />
            Accompagnement technique et service après-vente pour garantir un
            résultat fiable et durable.
          </p>
        </div>
      </section>
    </div>
  );
}
